import React, { FC, useState } from 'react';
import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Catalog } from '../types';
import CategoryModal from './CategoryModal';

export interface CategoryEditProps {
    category: Catalog,
    onSuccess: () => void,
};
//
// Редактирование категории у пользователя
//
const CategoryEdit:FC<CategoryEditProps> = ({ category, onSuccess }) => {
    const [ isModalOpen, setIsModalOpen ] = useState(false);

    return (
        <div className='btn'>
            <span onClick={() => setIsModalOpen(true)}>
                <Icon icon={faEdit} className='accent pointer'/>
            </span>
            <CategoryModal
                isOpen={isModalOpen}
                category={category}
                onClose={() => {
                    setIsModalOpen(false);
                    onSuccess();
                }}
            />
        </div>
    );
};

export default CategoryEdit;
